import * as ApiModels from '@typings/api-models';
import { RECURRING_INTERVALS_ABBREVIATED } from '@typings/Price';
import { logError } from '@providers/ErrorTracking';

const formatPriceInterval = (recurringInterval?: ApiModels.Interval | undefined | null): string => {
  if (!recurringInterval) {
    return '';
  }

  const intervalPart = RECURRING_INTERVALS_ABBREVIATED[recurringInterval];

  if (!intervalPart) {
    logError(new Error(`Unsupported recurringInteval: "${recurringInterval}"`));
    return '';
  }

  return `/${intervalPart}`;
};

export default formatPriceInterval;